var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-input',{staticClass:"mb-6",attrs:{"label":_vm.label,"messages":_vm.messages,"hideDetails":_vm.hideDetails}},[_c('span',{staticClass:"ml-3"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }